import React from "react";
import instanceCommerce from "../../../config/instanceCommerce.js";
import useTrackWebContext from "../../../hooks/useTrackWebContext";

const Metricsdivst = (props) => {
  const {
    dni_suscriptor,
    fecha_consumo,
    hora,
    importe_descuento,
    importe_compra,
    importe_total,
    nombre_suscriptor,
    nombre_colaborador,
    estado,
    id,
    setCurrentPage,
    nombre_sucursal,
    isBrand,
    isCommerce
  } = props;
  const { token, changeMetrics, setChangeMetrics } = useTrackWebContext();
  const deleteTransaction = async () => {
    setChangeMetrics(!changeMetrics);
    try {
      const body = {
        estado: 0,
      };
      const data = await instanceCommerce({
        url: `/api/transaction/${id}`,
        data: body,
        method: "PUT",
        headers: {
          Authorization: "Bearer " + token,
        },
      }).then((res) => {
        return res.data;
      });
      setCurrentPage(0);
      setTimeout(() => {
        setCurrentPage(1);
      }, 1000);
      setChangeMetrics(!changeMetrics);
      return data;
    } catch (error) {
      return false;
    }
  };
  const convertToLiteralNumber = (item) => {
    return item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };
  return (
    <tbody className="leading-4">
      <tr
        className={`text-left text-gray-700  border-b  ${
          estado === 0 ? "bg-neutral-100" : "bg-white"
        }`}
      >
        <th className="p-2 font-normal">{nombre_suscriptor}</th>
        <th className="p-2 font-normal">{dni_suscriptor}</th>
        <th className="p-2 font-normal">{fecha_consumo}</th>
        <th className="p-2 font-normal">{hora}</th>
        {isBrand ? (
          <th className="p-2 font-normal">{nombre_sucursal}</th>
        ) : null}
        <th className="p-2 font-normal">
          ${convertToLiteralNumber(importe_compra)}
        </th>
        <th className="p-2 font-normal">
          ${convertToLiteralNumber(importe_descuento)}
        </th>
        <th className="p-2 font-normal">
          ${convertToLiteralNumber(importe_total)}
        </th>
       {isCommerce && <th className="p-2 font-normal">{nombre_colaborador}</th>}
        {estado === 1 && (isCommerce || isBrand) && (
          <th className=" font-normal flex justify-center items-center mt-2">
            <button
              onClick={deleteTransaction}
              className="btn bg-clvblue text-white rounded-full h-8 px-2 pb-[2px]"
            >
              Anular
            </button>
          </th>
        )}
        {estado === 0 && (isCommerce || isBrand) && (
          <th className="font-normal m-3 text-center ">Transacción anulada</th>
        )}
      </tr>
    </tbody>
  );
};

export default Metricsdivst;
